(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drinks-product--flavor-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.flavor-selector').forEach(sel => {
    const titleSpan = sel.querySelector('h2 span');
    const options = sel.querySelectorAll('.flavor-option');
    if (!options.length) return;

    let current = sel.querySelector('.flavor-option.is-active') || options[0];

    function getName(li) {
      const hidden = li.querySelector('.visually-hidden');
      return hidden ? hidden.textContent.trim() : '';
    }

    function getSlug(li) {
      return (li.dataset.flavor || '').trim().toLowerCase();
    }

    function getUrl(li) {
      return li.dataset.url || null;
    }

    function applyTheme(slug) {
      sel.classList.forEach(cls => {
        if (cls.indexOf('color-') === 0) sel.classList.remove(cls);
      });
      if (slug) sel.classList.add('color-' + slug);
    }

    function preview(li) {
      if (!li || !titleSpan) return;
      titleSpan.textContent = getName(li);
      applyTheme(getSlug(li));
    }

    function commit(li) {
      options.forEach(o => {
        const active = o === li;
        o.classList.toggle('is-active', active);
        const btn = o.querySelector('button');
        if (btn) btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      current = li;
      preview(li);
    }

    options.forEach(li => {
      const btn = li.querySelector('button');

      li.addEventListener('mouseenter', () => preview(li));
      li.addEventListener('mouseleave', () => preview(current));

      li.addEventListener('focusin', () => preview(li));
      li.addEventListener('focusout', () => preview(current));

      if (btn) {
        btn.addEventListener('click', e => {
          e.preventDefault();
          commit(li);
          const url = getUrl(li);
          if (url) window.location.href = url;
        });
      }
    });

    // Init
    commit(current);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drinks-product--where-to-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('.where-to-buy-online .retailer');
    if (!link) {
      return;
    }
    var retailer = link.getAttribute('data-wtb-retailer') || '';
    var product  = link.getAttribute('data-wtb-product') || '';
    var market   = link.getAttribute('data-wtb-market') || '';
    var position = link.getAttribute('data-wtb-position') || '';
    var url      = link.href;
  
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "where_to_buy_click",
      retailer: retailer,
      product_handle: product,
      market: market,
      position: position,
      destination_url: url,
      link_domain: (new URL(url)).hostname
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supplements-product--where-to-buy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('.where-to-buy-online .retailer');
    if (!link) {
      return;
    }
    var retailer = link.getAttribute('data-wtb-retailer') || '';
    var product  = link.getAttribute('data-wtb-product') || '';
    var market   = link.getAttribute('data-wtb-market') || '';
    var position = link.getAttribute('data-wtb-position') || '';
    var url      = link.href;
  
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "where_to_buy_click",
      retailer: retailer,
      product_handle: product,
      market: market,
      position: position,
      destination_url: url,
      link_domain: (new URL(url)).hostname
    });
  });
  } catch(e) { console.error(e); }
})();

})();
